// services/childcare/incident-reports.js
import { api } from "./utils";

// Get incident reports
export const getIncidentReports = async (filters = {}) => {
  try {
    const response = await api.get("/childcare/incident-reports", {
      params: filters,
    });
    return response;
  } catch (error) {
    console.error("Error fetching incident reports:", error);
    throw error;
  }
};

// Get incidents by child
export const getIncidentsByChild = async (childId) => {
  try {
    const response = await api.get(
      `/childcare/incident-reports/child/${childId}`,
    );
    return response;
  } catch (error) {
    console.error("Error fetching child incidents:", error);
    throw error;
  }
};

// Get incidents by date range
export const getIncidentsByDateRange = async (startDate, endDate) => {
  try {
    const response = await api.get("/childcare/incident-reports/date-range", {
      params: { start_date: startDate, end_date: endDate },
    });
    return response;
  } catch (error) {
    console.error("Error fetching incidents by date range:", error);
    throw error;
  }
};

// Create incident report
export const createIncidentReport = async (incidentData) => {
  try {
    const response = await api.post(
      "/childcare/incident-reports",
      incidentData,
    );
    return response;
  } catch (error) {
    console.error("Error creating incident report:", error);
    throw error;
  }
};

// Update incident report
export const updateIncidentReport = async (id, incidentData) => {
  try {
    const response = await api.put(
      `/childcare/incident-reports/${id}`,
      incidentData,
    );
    return response;
  } catch (error) {
    console.error("Error updating incident report:", error);
    throw error;
  }
};

// Delete incident report
export const deleteIncidentReport = async (id) => {
  try {
    const response = await api.delete(`/childcare/incident-reports/${id}`);
    return response;
  } catch (error) {
    console.error("Error deleting incident report:", error);
    throw error;
  }
};

// Notify parent of incident
export const notifyParentOfIncident = async (id) => {
  try {
    const response = await api.post(
      `/childcare/incident-reports/${id}/notify-parent`,
    );
    return response;
  } catch (error) {
    console.error("Error notifying parent:", error);
    throw error;
  }
};

// Resolve incident
export const resolveIncident = async (id) => {
  try {
    const response = await api.post(
      `/childcare/incident-reports/${id}/resolve`,
    );
    return response;
  } catch (error) {
    console.error("Error resolving incident:", error);
    throw error;
  }
};
